import React from 'react';
import { cx } from '../../utils/cx.js';
import IconChip from './IconChip';

// The one surface of the app: white card, hairline border, soft shadow (Insights GPS cards).
export const CARD_SURFACE = 'rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-900 dark:bg-night-800';

export const Card = ({ as: Tag = 'section', className = '', children, ...rest }) => (
  <Tag className={cx(CARD_SURFACE, className)} {...rest}>
    {children}
  </Tag>
);

/**
 * Card header: icon chip + title (+ badge) + muted subtitle, actions on the right.
 * `divider` draws the hairline under it when the body starts with content, not padding.
 */
export const CardHeader = ({
  icon = null,
  iconTone = 'brand',
  title,
  titleAs: Title = 'h2',
  titleId,
  subtitle = null,
  badge = null,
  actions = null,
  divider = true,
  className = '',
}) => (
  <div className={cx('flex flex-wrap items-center gap-x-3 gap-y-2 px-4 py-3 sm:px-5', divider && 'border-b border-gray-100 dark:border-gray-900', className)}>
    {icon && <IconChip icon={icon} tone={iconTone} />}
    <div className="min-w-0 flex-1">
      <div className="flex flex-wrap items-center gap-2">
        <Title id={titleId} className="text-sm font-semibold text-gray-900 dark:text-white sm:text-base">{title}</Title>
        {badge}
      </div>
      {subtitle && <p className="mt-0.5 text-xs text-gray-500 dark:text-gray-400">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-shrink-0 flex-wrap items-center gap-2">{actions}</div>}
  </div>
);

export const CardBody = ({ className = '', children }) => (
  <div className={cx('p-4 sm:p-5', className)}>{children}</div>
);

export default Card;
